export default "__VITE_ASSET__BpHlEadY__"